import { useEffect, useState } from "react"
import { throttle } from "../utils"
import { isElementInViewport } from "../utils/isElementInViewport"

let number = 0
const useScroll = () => {
  const [pageNumber, setPageNumber] = useState(0)
  const [resetPage, setReset] = useState(false);

  const handleScroll = element => {
    const isInView = isElementInViewport(element, 600)
    if (isInView) {
      number++
      setPageNumber(number)
    }
  }

  useEffect(() => {
    const footer = document.querySelector("footer")
    document.body.addEventListener(
      "scroll",
      throttle(() => handleScroll(footer), 800)
    )
    return () =>
      document.body.removeEventListener(
        "scroll",
        throttle(() => handleScroll(footer), 800)
      )
  }, [])

  useEffect(() => {
    if (resetPage) {
      number = 0
      setReset(false);
    }
  }, [resetPage])

  return [pageNumber, setReset]
}

export default useScroll
